import React from "react";
import { Row, Container, Col } from "react-bootstrap";
import { GenerativeAIServiceTick } from "../../../app-constants";
import { Link } from "gatsby";
import {
  SEOServiceskeyword,
  SEOServicesLink,
  SEOServicesTechnical,
  SEOServicesLocal,
  SEOServicesOnPage,
  SEOServicesOffPage,
  SEOServicesFranchise,
  SEOServicesShopify,
  SEOServicesAmazon,
  SEOServicesEcommerce,
  SEOServicesContent,
  SEOServicesConversion,
} from "../../../app-constants-updated";

const WorkFlow = [
  {
    logo: GenerativeAIServiceTick,
    title: "Keyword Research & Strategy",
    description:
      "We provide you with a comprehensive list of targeted and niche-specific keywords best suited for your business. Our approach involves mapping these keywords to the user’s intent and trends to enhance your visibility and draw relevant traffic.",
    count: SEOServiceskeyword,
  },
  {
    logo: GenerativeAIServiceTick,
    title: "Link Building",
    description:
      "We offer link-building services that involve acquiring quality links from high-ranking sites to boost the credibility of the site being promoted. Our approach is to build backlinks that look natural and come from diverse sources to bolster your website domain.",
    count: SEOServicesLink,
  },
  {
    logo: GenerativeAIServiceTick,
    title: "Technical SEO",
    description:
      "We check and improve your websites on factors such as speed, mobile friendliness, and structured data to fit search engine standards. Our technical SEO services enable search engines to easily crawl and index your site and increase its ranking.",
    count: SEOServicesTechnical,
  },
  {
    logo: GenerativeAIServiceTick,
    title: "Local SEO",
    description:
      "We deal with local SEO and make sure your business is visible in local search engines and Google Maps. Our local SEO services include claiming, verifying, and creating your Google My Business listing, handling your online reviews, and creating local citations to help you rank higher within your area.",
    count: SEOServicesLocal,
  },
  {
    logo: GenerativeAIServiceTick,
    title: "On-Page SEO",
    description:
      "Our efforts are aimed at fine-tuning your Web pages’ content and HTML source code so that the pages can rank high in related search topics. Our on-page SEO services involve the appropriate placement of keywords, modification of meta tags, and proper structuring of webpages for search engine indexing.",
    count: SEOServicesOnPage,
  },
  {
    logo: GenerativeAIServiceTick,
    title: "Off-Page SEO",
    description:
      "Off-page SEO optimization promotes your site’s authority outside of the site, including link-making, social media communication, and other methods. We strive to establish a credible online presence that would increase organic traffic and rankings.",
    count: SEOServicesOffPage,
  },
  {
    logo: GenerativeAIServiceTick,
    title: "Franchise SEO",
    description:
      "We offer customized SEO solutions for franchises to get the best SEO results for the outlets. The franchise SEO plan involves researching localized keywords relevant to each point of sale, content creation for each branch, and citing each branch to encourage consumers to visit the outlets.",
    count: SEOServicesFranchise,
  },
  {
    logo: GenerativeAIServiceTick,
    title: "Shopify SEO",
    description:
      "Our Shopify SEO services are specific for improving the ranking of your Shopify store and making it more visible. We primarily work on product pages, page loading speed, and product keywords to help your store rank higher in search engine results and increase sales.",
    count: SEOServicesShopify,
  },
  {
    logo: GenerativeAIServiceTick,
    title: "Amazon SEO",
    description:
      "We ensure your Amazon product listings are properly enhanced to improve its ranking and boost its sales on Amazon. Amazon SEO services that we can offer are keyword optimization, changes to product descriptions, and competitor evaluations.",
    count: SEOServicesAmazon,
  },
  {
    logo: GenerativeAIServiceTick,
    title: "eCommerce SEO",
    description:
      "Our eCommerce SEO services involve an optimization of the online store so that it can rank well within search engines. You can improve product pages, category pages, and site positions to make your store visible to potential buyers and attract more visitors and customers.",
    count: SEOServicesEcommerce,
  },
  {
    logo: GenerativeAIServiceTick,
    title: "Content Writing",
    description:
      "Our professional content writing services develop content that is original, compelling, and optimized for search engines to suit your business needs. We create engaging blog content, articles, product descriptions, and website content, which best suits the tone and objectives of your brand.",
    count: SEOServicesContent,
  },
  {
    logo: GenerativeAIServiceTick,
    title: "Conversion Rate Optimization (CRO)",
    description:
      "We study user patterns on your website and use the necessary methods to increase the conversion rate. Our CRO services entail optimizing landing pages, increasing customer engagement as well as performing experiments through A/B testing to increase the conversion rate of visitors into customers.",
    count: SEOServicesConversion,
  },
];
const Workflow = () => {
  return (
    <div
      className="workflow p-100 nlp_process_flow search-engine-workflow worflow_seo"
      style={{ background: "#F6F6F6" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>Our SEO Services</h2>
            <p>
              We offer all-inclusive SEO packages to help you boost your online
              traffic and achieve organic and lasting results. By applying
              proper technical approaches and following modern trends, your
              enterprise will be easily noticed in the overloaded flow.
            </p>
          </Col>
        </Row>
        <Row className="workflow_secion">
          {WorkFlow.map((item, index) => (
            <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-3 mb-md-4">
              <div
                className="workflow_items"
                style={{ background: "#fff", pointerEvents: "none" }}
              >
                <div className="item_name">
                  <span style={{ marginBottom: "10px" }}>{item.count}</span>
                  {item.title}
                  <div className="item_icon"> {item.logo}</div>
                </div>
                <p>{item.description}</p>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default Workflow;
